/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IpsIcon extends BaseIcon {
  getChildren = () => [
    <path fill={ this.getColor() }
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16,4h-1V3.6L16,4z M14,5V4h1v1H14z M13,3h0.7L14,3.1V4h-1V3z M11,4V3h1v1H11z M10,2h1v1h-1V2z M9,3h1v1H9v1h1 v1H9v1h1v1H9v1h1v1H9v1h1v1H9v1h1v1H9v1h1v0.6L9,16H8l-5-2L1,4l7-3h1l1,0.4V2H9V3z M11,14v1h-1v-1H11z M12,13v1h-1v-1H12z M14,13v1 h-1v-1H14z M13,11h1v1h-1V11z M13,9h1v1h-1V9z M15,8v1h-1V8H15z M14,6h1v1h-1V6z M13,6V5h1v1H13z M12,4h1v1h-1V4z M10,5V4h1v1H10z M11,7h-1V6h1V7z M11,9h-1V8h1V9z M11,11h-1v-1h1V11z M11,13h-1v-1h1V13z M13,12v1h-1v-1H13z M12,10h1v1h-1V10z M12,8h1v1h-1V8z M14,7v1h-1V7H14z M12,7V6h1v1H12z M12,8h-1V7h1V8z M12,10h-1V9h1V10z M12,12h-1v-1h1V12z M11,5h1v1h-1V5z M15.8,5l-0.2,1H15V5H15.8 z M15.4,7l-0.2,1H15V7H15.4z M15,9L15,9L15,9L15,9z M14.8,10l-0.2,1H14v-1H14.8z M14.4,12l-0.2,1H14v-1H14.4z M13,14.4l-1,0.4V14h1 V14.4z M11,15.2V15h0.5L11,15.2z M11.3,2H11V1.9L11.3,2z M12,2.3l1,0.4V3h-1V2.3z"/>
  ]
  getViewBox = () => '0 0 16 16'
}
